import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createEntryProductsSchemas } from 'shared/db/validation/schema/entryProducts';
import { Validator } from 'shared/db/validation/validator';
import {
    EntryProductRawRecord,
    EntryProductUpdateRawRecord,
} from 'shared/types/EntryProduct';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { EntryProductDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createEntryProductsSchemas();

const addValidator = createDBEntityValidator<EntryProductRawRecord>(
    schemas.add,
);
const updateValidator = createDBEntityValidator<EntryProductUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-entry-products'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createEntryProductsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const entryProductsInputValidation: EntryProductDBValidation = {
    add: createEntryProductsInputValidation(addValidator, validationStrategy),
    update: createEntryProductsInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createEntryProductsInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
